// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1PIAy","cardTitle":"card_cardTitle__2lGCH","cardText":"card_cardText__3D3oa","cardLink":"card_cardLink__2RjGz"};